// dependencies
// import xmldom from 'xmldom'

if (typeof btoa === 'undefined') {
  global.btoa = function (str) {
    return Buffer.from(str, 'binary').toString('base64')
  }
}

// Default properties
export const SLIDE_SIZE_INCHES = { x: 10, y: 5.625 }
export const SLIDE_SIZE_PX = { x: 1920, y: 1080 }

export function percentageToInches(percentage, axis) {
  return SLIDE_SIZE_INCHES[axis] * percentage
}

export function hasProperty(property, obj) {
  return obj.properties && typeof obj.properties[property] !== 'undefined'
}

export function getProperty(node, property, defaultValue) {
  return hasProperty(property, node) ? node.properties[property] : defaultValue
}

export function hasChildren(node) {
  return (
    typeof node === 'object' && typeof node.children !== 'undefined' && node.children.length > 0
  )
}

export function getCoordinates({ x, y }, parent) {
  return {
    x: percentageToInches(x / 1920 + parent.xAcc, 'x'),
    y: percentageToInches(y / 1080 + parent.yAcc, 'y'),
  }
}

export function joinTextValues(textNode) {
  return hasChildren(textNode)
    ? textNode.children
        .reduce((acc, child) => {
          if (hasChildren(child)) {
            return decodeHtmlString(`${acc}${child.children[0].value} `)
          }

          return decodeHtmlString(`${acc}${child.value} `)
        }, '')
        .trimRight()
    : ''
}

export function getTextValues(textNode) {
  return hasChildren(textNode)
    ? textNode.children.map((child) => {
        if (hasChildren(child)) {
          return `${decodeHtmlString(child.children[0].value)}`
        }

        return `${decodeHtmlString(child.value)} `
      }, '')
    : ''
}

export function decodeHtmlString(string) {
  return string != undefined ? string.replace(/&amp;/g, '&') : ''
}

export function decodeHtml(html) {
  let txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}

export function addSvg(XML, slide, viewBox, imagePosition) {
  const originalWidth = viewBox.split(' ')[2]
  const originalHeight = viewBox.split(' ')[3]
  const aspectRatio = originalWidth / originalHeight

  const base64 = btoa(XML.replace(/symbol/g, 'svg'))
  const data = `data:image/svg+xml;base64,${base64}`

  const calculatedWidth = percentageToInches((imagePosition.h * aspectRatio) / 5.5, 'y')
  const translateX = (imagePosition.w - calculatedWidth) / 2

  slide.addImage({
    data,
    ...imagePosition,
    x: imagePosition.x + translateX,
    w: calculatedWidth,
  })
}
